import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AddPhotoImageData } from "../../../types";
import { addReview, addReviewDesktop } from "../../../apis";
import { Storage } from "common/storage";

export function usePostVenueReview(isDesktop?: boolean) {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = useQueryClient();
  const { mutate, error, status, data } = useMutation({
    mutationFn: ({
      venueId,
      review,
      images,
      accessibilityExperience,
    }: {
      images: AddPhotoImageData[];
      venueId: string;
      review: string;
      accessibilityExperience: string;
    }) => {
      return isDesktop
        ? addReviewDesktop(
            venueId,
            review,
            images,
            accessibilityExperience,
            accessToken || "",
          )
        : addReview(
            venueId,
            review,
            images,
            accessibilityExperience,
            accessToken || "",
          );
    },
    onSuccess: (_, { venueId }) => {
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: ["loadVenueDetailsBySlug"],
          exact: false,
        });
      }, 2000);
      // The Scout badge step for this action is recorded server-side on this
      // endpoint's success path, so the new progress only reaches the app when
      // `sync-user` refetches.
      // Not inside the timeout above: that delay is there to let the review
      // land in the venue's own aggregates, and badge progress does not wait
      // on it.
      queryClient.invalidateQueries({
        queryKey: ["userSync"],
        exact: false,
      });
    },
  });

  return { mutate, error, status, data };
}
